// Core Imports
import { mockBackendErrors } from '@/core/config/backend-errors-mock'

// Module Imports
import { authBackendErrors } from '@/modules/auth/auth.constants'
import { avatarBackendErrors } from '@/modules/avatar/avatar.constants'
import { categoryBackendErrors } from '@/modules/category/category.constants'
import { emoteBackendErrors } from '@/modules/emote/emote.constants'
import { playerBackendErrors } from '@/modules/player/player.constants'
import { questionBackendErrors } from '@/modules/question/question.constants'
import { questionPoolBackendErrors } from '@/modules/question-pool/question-pool.constants'
import { adminUsersBackendErrors } from '@/modules/admin/admin.constants'
import { roleBackendErrors } from '@/modules/role/role.constants'
import { teamBackendErrors } from '@/modules/team/team.constants'
import { userRoleBackendErrors } from '@/modules/user-role/user-role.constants'

export const backendErrors = {
  // For Testing Only
  test: mockBackendErrors,

  auth: authBackendErrors,
  category: categoryBackendErrors,
  question: questionBackendErrors,
  questionPool: questionPoolBackendErrors,
  avatar: avatarBackendErrors,
  emote: emoteBackendErrors,
  player: playerBackendErrors,
  admin: adminUsersBackendErrors,
  role: roleBackendErrors,
  userRole: userRoleBackendErrors,
  team: teamBackendErrors,
} as const

export type BackendErrors = typeof backendErrors
export type Prefix = keyof BackendErrors
export type BackendErrorKeys<P extends Prefix> = keyof BackendErrors[P]
